var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 55,
    viewBox: "0 0 64 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8028 1.17665C57.575 0.85162 58.4203 0.73952 59.2506 0.852015C60.0808 0.96451 60.8658 1.29749 61.5237 1.81629C62.1816 2.33509 62.6884 3.02075 62.9914 3.80191C63.2944 4.58306 63.3825 5.43115 63.2465 6.2579L56.159 49.2485C55.4715 53.3954 50.9215 55.7735 47.1184 53.7079C43.9372 51.9798 39.2122 49.3173 34.9622 46.5391C32.8372 45.1485 26.3278 40.6954 27.1278 37.5267C27.8153 34.8173 38.7528 24.636 45.0028 18.5829C47.4559 16.2048 46.3372 14.8329 43.4403 17.0204C36.2465 22.4516 24.6965 30.711 20.8778 33.036C17.509 35.086 15.7528 35.436 13.6528 35.086C9.82152 34.4485 6.2684 33.461 3.3684 32.2579C-0.55035 30.6329 -0.359725 25.2454 3.36528 23.6766L56.8028 1.17665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.07736064abd1d037170ee8ed15805491.svg";
export { ForwardRef as ReactComponent };